module.exports = __webpack_public_path__ + "img/TCALCI_broad_male_90.c1bc346e.png";